import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import PaymentPage from "./Components/pages/PaymentPage";
import NotFound from "./Components/NotFound";
import ReactGA from 'react-ga';

export default function App() {
  useEffect(() => {
    ReactGA.initialize(process.env.REACT_APP_GA_ID);
    ReactGA.pageview(window.location.pathname);
  }, []);

  return (
    <Router>
        <Switch>
          <Route exact path="/pay/:paymentId" component={PaymentPage} />
          <Route exact path="/not-found" component={NotFound} />
          <Redirect to="/not-found" />
        </Switch>
    </Router>
  );
}